import { render, staticRenderFns } from "./PreschoolGroups.vue?vue&type=template&id=44afbc51&"
import script from "./PreschoolGroups.vue?vue&type=script&lang=js&"
export * from "./PreschoolGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports